<template>
  <v-navigation-drawer
    class="category-drawer"
    v-model="categoryToggle"
    app
    temporary
  >
    <div :style="{ marginTop: categoryNavTop }" class="px-3 py-4">
      <div class="hb-title">FILTER</div>
      <div class="step-title">Categories</div>
      <v-radio-group v-model="currentCategory">
        <v-radio v-for="category in categories" :key="category.product_type" :label="category.product_type" :value="category.product_type"></v-radio>
      </v-radio-group>
      <div class="step-title">Price Range</div>
      <v-radio-group v-model="selectedPriceRange">
        <v-radio v-for="p in priceRange" :key="p.value" :label="p.label" :value="p.value">
        </v-radio>
      </v-radio-group>
    </div>
    <div class="px-4 mt-0 mb-4 d-flex justify-space-between">
      <v-btn @click="closeCategoryDrawer" outlined style="flex: 1 0 18%" color="primary" class="mr-2">
        <v-icon class="primary--text">mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn @click="closeCategoryDrawer" style="flex: 1 0 80%" color="primary">
        Apply
      </v-btn>
    </div>

  </v-navigation-drawer>
</template>

<script>
import moment from 'moment';
import { getGifts } from '../api/products';
import {TYPE_SET_CATEGORY_TOGGLE, TYPE_SET_CURRENT_CATEGORY, TYPE_SET_GIFTS, TYPE_SET_SELECTED_PRICE_RANGE} from '../store/mutations'
export default {
  name: "hb-bab-category-drawer",
  data() {
    return {
      priceRange: [
        {
          label: 'All Price',
          value: 'all'
        },
        {
          label: '0 - 50',
          value: '50',
          min: '0',
          max: '50'
        },
        {
          label: '50 - 100',
          value: '100',
          min: '50',
          max: '100'
        },
        {
          label: '100 - 200',
          value: '200',
          min: '100',
          max: '200'
        }
      ],
    };
  },
  methods:{
      closeCategoryDrawer(){
          this.$store.commit(TYPE_SET_CATEGORY_TOGGLE, false);
      },
      updateGifts(){
        
      }
  },
  computed: {
    categoryNavTop(){
      const topNav = document.querySelector(".main-header-wrapper");
      if(!topNav || topNav?.clientHeight == 0)
        return '71px';
      return topNav.clientHeight + "px";
    },
    categoryToggle: {
      get() {
        return this.$store.state.categoryToggle;
      },
      set(value) {
        this.$store.commit(TYPE_SET_CATEGORY_TOGGLE, value);
      },
    },
    categories() {
      return this.$store.state.categories;
    },
    currentCategory:{
      get(){
        return this.$store.state.currentCategory;
      },
      set(value){
        this.$store.commit(TYPE_SET_CURRENT_CATEGORY, value);
      }
    },
    selectedPriceRange:{
      get(){
        return this.$store.state.selectedPriceRange;
      },
      set(value){
        this.$store.commit(TYPE_SET_SELECTED_PRICE_RANGE,value)
      }
    }
  },
  watch:{
    async selectedPriceRange(val){
      let price = {
        price_min: null,
        price_max: null,
        date: moment(this.$store.state.delivery.delivery_date).format('YYYYMMDD')
      }

      const curPrice = this.priceRange.find(p => p.value == val);

      if(val.value !== 'all'){
        price.price_min = curPrice.min;
        price.price_max = curPrice.max;
      }

      this.$store.commit(TYPE_SET_GIFTS, null);
      this.$store.commit(TYPE_SET_GIFTS, await getGifts(price));
    }
  }
};
</script>

<style>
</style>